<template>
    <div class="info-row">
      <span class="info-row-title" v-if="category === 1">{{name}}：</span>
      <div class="info-row-title info-row-title2" v-else>{{name}}</div>
      <span class="info-row-value">
        <span>{{ _value }}</span>
        <slot></slot>
      </span>
    </div>
</template>

<script setup>
import {computed, ref} from 'vue';
const props = defineProps({
  name: String,
  value: String,
  category: undefined | null | Number,
  dot: Boolean
})
const visible=ref(false);

const _value = computed(() => {
  if(!props.value){
    return '/';
  }
  let v = String(props.value);
  if(v.length > 6 && props.dot) {
    return v.slice(0, 6) + '...';
  }
  return v;
})
</script>

<style scoped>
.info-row{
  display: flex;
  flex-direction: row;
}

.extra-item span{
  display: inline-block;
  width: 30px;
}

.info-row-title, .info-row-value{
  height: 30px;
  line-height: 30px;
  position: relative;
  cursor: pointer;
}

.info-row-title{
  color: #3488f6;
}

.info-row-title2{
  display: inline-block;
  width: 100px;
}

.info-row-value{
  color: #3a3a3a;
}

.info-row.info-row-slot{
  height: auto;
}
</style>